import React from 'react'
import { storiesOf } from '@storybook/react'

import Rank from 'components/Rank'

import range from 'lodash-es/range'

storiesOf('Rank', module)
  .add('default', () => (
    <div>
      {range(10).map((i) => <div key={i}><Rank value={i} /></div>)}
    </div>
  ))
